import * as yup from "yup";

export const formAnimalSchema = yup.object().shape({
  nome: yup.string().required("Campo obrigatório")
});

export type FormAnimalValues = {
  nome: string;
  especie: number | string;
  raca: string | string;
  sexo: number | string;
  porte: number | string;
  idadeAnos: number | null;
  idadeMeses: number | null;
  pelagem: string;
  peso: number;
  corPredominante: string;
  doencasPreexistentes: number[] | string[];
  castrado: boolean | string;
  desejaCastrar: boolean | string;
  vacinaEmDia: boolean | string;
  desejaVacinar: boolean | string;
  dataUltimaVacinacao: string | null;
  dataObito: string | null;
};
